<script setup lang="ts">
import { EProviders, type SocketProviderType } from '@rfc/rfc-components-library/types'
import { computed, provide } from 'vue'

const socketProvider = computed<SocketProviderType>(() => ({
    alertsSocket: { url: import.meta.env.VITE_SOCKET_URL, path: 'device' },
    detectionsSocket: { url: import.meta.env.VITE_SOCKET_URL, path: 'tag-producer-detections' },
    configSocket: { url: import.meta.env.VITE_SOCKET_URL }
}))

provide<SocketProviderType>(EProviders.SOCKET, socketProvider.value)
</script>

<template>
    <slot />
</template>
